var _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServices6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 9,
    fill: "#25BCBD",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_75_986",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 29,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H36.2524V36.2524H8V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_75_986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6225 9.17712H12.6299C11.7142 9.17712 10.836 9.54089 10.1885 10.1884C9.54095 10.8359 9.17719 11.7141 9.17719 12.6298V31.6225C9.17719 32.5382 9.54095 33.4164 10.1885 34.0639C10.836 34.7114 11.7142 35.0752 12.6299 35.0752H31.6225C32.5382 35.0752 33.4164 34.7114 34.0639 34.0639C34.7115 33.4164 35.0752 32.5382 35.0752 31.6225V12.6298C35.0752 11.7141 34.7115 10.8359 34.0639 10.1884C33.4164 9.54089 32.5382 9.17712 31.6225 9.17712Z",
    stroke: "#25BCBD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7779 20.3604H27.7178C27.6119 20.0308 27.4824 19.7248 27.3294 19.4187L28.7891 17.959C29.4836 17.2644 29.4836 16.1461 28.7891 15.4633C28.0945 14.7806 26.9762 14.7688 26.2934 15.4633L24.8337 16.9231C24.5394 16.77 24.2216 16.6405 23.892 16.5346V14.4745C23.892 13.4975 23.1033 12.7087 22.1262 12.7087C21.1491 12.7087 20.3604 13.4975 20.3604 14.4745V16.5346C20.0308 16.6405 19.7248 16.77 19.4187 16.9231L17.959 15.4633C17.7958 15.2982 17.6015 15.1671 17.3873 15.0776C17.1731 14.9881 16.9433 14.942 16.7112 14.942C16.479 14.942 16.2492 14.9881 16.035 15.0776C15.8208 15.1671 15.6265 15.2982 15.4633 15.4633C14.7806 16.1579 14.7688 17.2762 15.4633 17.959L16.9231 19.4187C16.77 19.713 16.6405 20.0308 16.5346 20.3604H14.4745C13.4975 20.3604 12.7087 21.1491 12.7087 22.1262C12.7087 23.1033 13.4975 23.892 14.4745 23.892H16.5346C16.6405 24.2216 16.77 24.5277 16.9231 24.8337L15.4633 26.2934C15.2982 26.4566 15.1671 26.6509 15.0776 26.8651C14.9881 27.0793 14.942 27.3091 14.942 27.5412C14.942 27.7734 14.9881 28.0032 15.0776 28.2174C15.1671 28.4316 15.2982 28.6259 15.4633 28.7891C16.1579 29.4836 17.2762 29.4836 17.959 28.7891L19.4187 27.3294C19.713 27.4824 20.0308 27.6119 20.3604 27.7178V29.7779C20.3604 30.755 21.1491 31.5437 22.1262 31.5437C23.1033 31.5437 23.892 30.755 23.892 29.7779V27.7178C24.2216 27.6119 24.5277 27.4824 24.8337 27.3294L26.2934 28.7891C26.988 29.4836 28.1063 29.4836 28.7891 28.7891C29.4836 28.0945 29.4836 26.9762 28.7891 26.2934L27.3294 24.8337C27.4824 24.5394 27.6119 24.2216 27.7178 23.892H29.7779C30.755 23.892 31.5437 23.1033 31.5437 22.1262C31.5437 21.1491 30.755 20.3604 29.7779 20.3604Z",
    stroke: "#25BCBD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1262 24.4806C22.7506 24.4806 23.3494 24.2325 23.7909 23.791C24.2325 23.3495 24.4805 22.7506 24.4805 22.1262C24.4805 21.5018 24.2325 20.903 23.7909 20.4614C23.3494 20.0199 22.7506 19.7719 22.1262 19.7719C21.5017 19.7719 20.9029 20.0199 20.4614 20.4614C20.0198 20.903 19.7718 21.5018 19.7718 22.1262C19.7718 22.7506 20.0198 23.3495 20.4614 23.791C20.9029 24.2325 21.5017 24.4806 22.1262 24.4806Z",
    stroke: "#25BCBD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices6);
export default __webpack_public_path__ + "static/media/Services6.ece8667606c2b283268efe5d629fc771.svg";
export { ForwardRef as ReactComponent };